<template>
  <div>
    <main-header></main-header>
    <div class="page">
      <div class="w1200">
        <div class="shippint-toptitle">
          <div class="left">
            {{language[languagetype].wjxz}}
          </div>
          <div class="right" @click="back">
            {{language[languagetype].backa}}
          </div>
        </div>
        <div class="goodspage-main">
          <div class="order-title">
            {{language[languagetype].wjlb}}
          </div>
          <div class="order-main-table">
            <div class="order-main-table-th">
              <div></div>
              <div>{{language[languagetype].serial}}</div>
              <div>{{language[languagetype].filename}}</div>
              <div>{{language[languagetype].xz}}</div>
            </div>
            <ul class="order-main-tabletdlist">
              <li class="order-main-table-td" v-for="(downs,index) in downlist" :key="index">
                <div></div>
                <div>{{index + 1}}</div>
                <div>{{downs.fileName}}</div>
                <div>
                  <a :href="downs.fileDownLoadUrl" class="a2" target="_blank">{{language[languagetype].xz}}</a>
                </div>
              </li>
            </ul>
            <!-- <div class="newslist-pageindex">
              <a href="javascript:;" @click="page(1)">{{language[languagetype].first}}</a>
              <a href="javascript:;" @click="page(cur-1)">{{language[languagetype].prev}}</a>
              <a href="javascript:;" v-if="cur >= 2 && all!=2">...</a>
              <a href="javascript:;" v-for="index in pageindexarr" :key="index" @click="page(index)" :class="{active:cur===index}">{{index}}</a>
              <a href="javascript:;" v-if="all > 2">...</a>
              <a href="javascript:;" @click="page(cur+1)">{{language[languagetype].next}}</a>
              <span>{{language[languagetype].gonga}}{{alllength}}{{language[languagetype].tiao}} {{language[languagetype].gongb}}{{all}}{{language[languagetype].ye}}</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <toast ref="toasttext"></toast>
  </div>
</template>

<script>
import MainHeader from './header'
import toast from '../components/taast/toast'
import httppost from '../js/ajax'
let languagetext = require('../js/goodspage.json')
export default {
  name: 'about',
  data () {
    return {
      downlist: [],
      language: {},
      languagetype: 'cn',
      all: 1,
      cur: 1,
      alllength: 1,
      pageindexarr: []
    }
  },
  methods: {
    page (index) {

    },
    back: function () {
      if (this.$route.params.find === 1) {
        this.$router.push({name: 'order', params: { find: 1 }})
      } else {
        this.$router.go(-1)
      }
    }
  },
  components: {
    MainHeader,
    toast
  },
  created () {
    const that = this
    that.language = languagetext
    that.lang = sessionStorage.getItem('lang') || 1
    // eslint-disable-next-line
    if (that.lang != 1) {
      that.languagetype = 'en'
    }
    that.username = JSON.parse(localStorage.getItem('username'))
    httppost.post('Api/http', {
      name: 'portal.sea.orderDetail.query',
      customerName: that.username.customerName,
      casenumber: that.$route.params.id
    }).then((res) => {
      if (res.code === '0') {
        that.downlist = res.data.fmsExternalOrderDetailList[0].remarks
      } else {
        that.$refs.toasttext.show(res.msg)
      }
    }).catch(err => {
      that.$refs.toasttext.show(err.msg)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page{min-height: 400px;background-color: #f6f6f6;}
  .shippint-toptitle{height: 92px;padding-top: 9px;display: flex;justify-content: space-between;}
  .shippint-toptitle .left{line-height: 92px;color: #333;font-size: 30px;}
  .shippint-toptitle .right{color: #999;font-size: 16px;line-height: 92px;cursor: pointer;background:url("../assets/backbtn.png") 0 center no-repeat;padding-left: 27px;}
  .goodspage-brand{width: 100%;height: 220px;overflow: hidden;position: relative;margin-top: 21px;}
  .goodspage-main{width: 100%;height: auto;overflow: hidden;background-color: #fff;box-sizing: border-box;padding: 0 30px 20px 30px;margin-top: 20px;}
  .order-main-table{width: 100%;height: auto;box-sizing: border-box;padding-bottom: 15px;}
  .order-main-table-th{width: 100%;height: 50px;overflow: hidden;display: flex;background-color: #f6f6f6;}
  .order-main-table-th div{flex-shrink: 0;height: 50px;font-weight: bold;line-height: 50px;}
  .order-main-table-th div:nth-child(1){width: 23px;}
  .order-main-table-th div:nth-child(2){width: 153px;}
  .order-main-table-th div:nth-child(3){width: 795px;}
  .order-main-table-th div:nth-child(4){width: 170px;}
  .order-main-tabletdlist{width: 100%;height: auto;overflow: hidden;}
  .order-main-tabletdlist li{width: 100%;height: auto;overflow: hidden;}
  .order-main-tabletdlist li:nth-child(even){background-color: #f6f6f6;}
  .order-main-table-td{width: 100%;height: auto;display: flex;}
  .order-main-table-td div{flex-shrink: 0;height: 65px;min-height: 65px;color: #999999;font-size: 12px;line-height: 65px;box-sizing: border-box;box-sizing: border-box;padding-left: 4px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;}
  .order-main-table-td div span{line-height: 35px;display: block;width: 100%;height: auto;}
  .order-main-table-td div a{color: #2D5CC8;}
  .order-main-table-td div:nth-child(1){width: 23px;}
  .order-main-table-td div:nth-child(2){width: 153px;}
  .order-main-table-td div:nth-child(3){width: 795px;}
  .order-main-table-td div:nth-child(5){width: 170px;display: flex;justify-content: center;}
  .order-main-table-td:hover{background-color: #a4b3d7!important;}
  .order-main-table-td:hover div,.order-main-table-td:hover a{color: #fff;}
  .order-title{width: 100%;height: 55px;line-height: 55px;font-size: 18px;}
  .order-main-table-td .a2{padding-left: 23px;background:url("../assets/heise_x_z.png") 0 center no-repeat;display: block;}
  .order-main-table-td:hover .a2{padding-left: 23px;background:url("../assets/baise_x_z.png") 0 center no-repeat;display: block;}
  .newslist-pageindex{width: 100%;height: auto;overflow: hidden;text-align: center;margin-bottom: 5px;margin-top: 15px;}
  .newslist-pageindex a{display: inline-block;width: auto;height: 32px;background-color: #f2f2f2;color: #333333;font-size: 14px;line-height: 32px;min-width: 32px;box-sizing: border-box;padding: 0 5px; margin-left: 5px;margin-right: 5px;}
  .newslist-pageindex .active{background-color: #2a3c66;color:#fff}
  .newslist-pageindex a:hover{background-color: #2a3c66;color:#fff}
</style>



// WEBPACK FOOTER //
// src/page/gooddown.vue